import axios from 'axios';
const WC_ID = 'cdkedkk4s26fsmnkhrhg';
export const MOCK_RESPONSE = {
  matches: [
    {
      id: 'c944stemhftbd9bgta00',
      sport: 'soccer',
      sport_code: 'soccer',
      competition_name: 'Copa del Mundo 2022',
      start_date: '2022-11-21 16:00:00+00',
      name: 'Catar v Ecuador',
      home_player: 'Catar',
      away_player: 'Ecuador',
      country: '',
    },
    {
      id: 'cdiit5umhftbf3sl2m9g',
      sport: 'soccer',
      sport_code: 'soccer',
      competition_name: 'Copa del Mundo 2022',
      start_date: '2022-11-20T00:00:00Z',
      name: 'Bélgica v Marruecos',
      home_player: 'Bélgica',
      away_player: 'Marruecos',
      country: '',
    },
  ],
  already_published_match_ids: ['c944stemhftbd9bgta00'],
};
export const worldCupMatchesRequest = () =>
  axios.get(`/v1/competitions/${WC_ID}/matches/upcoming`);
